<template>
  <div>    
    <router-view />
    <VueCookieAcceptDecline :element-id="'myPanel1'">
      <div slot="message">
        Cookies helfen uns, unsere Webinhalte zu verbessern und ein personalisiertes Erlebnis zu bieten. Durch die Nutzung dieser Website erklären Sie sich mit der Verwendung von Cookies einverstanden.
        <a
          href="/policy"
          target="_blank"
        >Siehe auch unsere Datenschutzerklärung.</a>
      </div>

      <!-- Optional -->
      <div slot="declineContent">
        Verweigern
      </div>

      <!-- Optional -->
      <div slot="acceptContent">
        Akzeptieren
      </div>
    </VueCookieAcceptDecline>
    <!-- Optional -->
  </div>
</template>

<style>
</style>

<script>
import "vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css";

import VueCookieAcceptDecline from "vue-cookie-accept-decline";

export default {
  components: {
    VueCookieAcceptDecline
  }
};
</script>